import * as R from 'ramda'
import {
    array, Decoder, equal, field, number,
    object
} from 'json-bouncer'
import {Result} from '../Data/Result'

export interface PriceDefinition {
    readonly id: number
    readonly priceGroupId: number
    readonly minQuantity: number
    readonly netFixedCosts: number
    readonly grossFixedCosts: null
    readonly netVariableCosts: number
    readonly grossVariableCosts: null
}

export interface PriceDefinitionProductCalculationPatch {
    readonly id: number
    readonly minQuantity: number
    readonly netVariableCosts: number
    readonly deleted: boolean
}

export function priceDefinitionListDecoder(): Decoder<PriceDefinition[]> {
    return array(priceDefinitionDecoder())
}

export function priceDefinitionDecoder(): Decoder<PriceDefinition> {
    return object({
        id: field('id', number()),
        priceGroupId: field('priceGroupId', number()),
        minQuantity: field('minQuantity', number()),
        netFixedCosts: field('netFixedCosts', number()),
        grossFixedCosts: field('grossFixedCosts', equal(null)),
        netVariableCosts: field('netVariableCosts', number()),
        grossVariableCosts: field('grossVariableCosts', equal(null)),
    })
}

export function calculatePrice(
    priceDefinitions: PriceDefinition[],
    amount: number
): Result<string, number> {
    const priceDefinition =
        R.findLast(
            definition =>
                amount >= definition.minQuantity,
            R.sortBy(
                d => d.minQuantity,
                priceDefinitions,
            ),
        )
    if (typeof priceDefinition !== 'undefined') {
        return {
            type: 'Ok',
            value:
            priceDefinition.netFixedCosts +
            priceDefinition.netVariableCosts * amount,
        }
    } else {
        return {type: 'Err', error: `No price definition for amount ${amount}`}
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PriceDefinition.ts